// extracted by mini-css-extract-plugin
export default {"wrapper":"MessageHistoryTab_wrapper__FvH3M"};